import { type ChainflipChain } from '@chainflip/utils/chainflip';
import { getChainTrackingQuery } from '@/shared/graphql/explorer/queries';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import { parseIntOrThrow } from '@/shared/utils/numbers';

export default function useChainTracking({ enabled }: { enabled: boolean }) {
  const { data = null } = useGqlQuery(getChainTrackingQuery, {
    select: (result) => {
      if (result.allChainTrackings == null) return null;

      return Object.fromEntries(
        result.allChainTrackings.nodes.map(
          ({ chain, height }) => [chain, parseIntOrThrow(height)] as const,
        ) ?? [],
      ) as Record<ChainflipChain, number>;
    },
    refetchInterval: 30_000,
    enabled,
  });

  return data;
}
